import { Link } from "@tanstack/react-router";
import { Sparkles } from "lucide-react";
import { formatISODateRelative } from "lib/formatISODate";
import { FavoriteButton } from "./FavoriteButton";

interface DigestData {
    id: number;
    createdAt: string;
    type: "NEWS" | "SOCIAL";
    title: string;
    content: string;
    summary: string | null;
    featuredImageURL: string;
}

export const DigestCard = ({ summary, target }: { summary: DigestData; target?: string }) => (
    <Link
        to="/digest/$id"
        params={{ id: String(summary.id) }}
        target={target}
        className="block rounded-2xl border border-indigo-200 bg-indigo-50/50 p-4 no-underline shadow-sm transition-shadow hover:shadow-md"
    >
        <div className="mb-2 flex items-center justify-between">
            <div className="flex items-center gap-1.5">
                <Sparkles className="h-4 w-4 text-indigo-500" />
                <span className="rounded-full bg-indigo-100 px-2 py-0.5 text-[10px] font-medium text-indigo-600">
                    {summary.type === "NEWS" ? "News Digest" : "Social Digest"}
                </span>
            </div>
            <FavoriteButton target={{ type: "sitewideSummary", id: summary.id }} size={16} />
        </div>
        <h3 className="line-clamp-2 text-base font-semibold text-gray-900">{summary.title}</h3>
        {summary.summary && (
            <p className="line-clamp-3 mt-1 text-sm text-gray-600">{summary.summary}</p>
        )}
        <p className="mt-2 text-xs text-gray-400">{formatISODateRelative(summary.createdAt)}</p>
    </Link>
);
